module.exports = __webpack_public_path__ + "img/SecHacienda.d54974bd.png";